// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "ChatRegressionJudgeComparison" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";

export const ChatRegressionJudgeComparisonGenShape = z.strictObject({
  issueIndex: z.number(),
  confidence: z.number(),
  locatorTopId: z.string().optional(),
  judgePrimaryId: z.string().optional(),
  overturned: z.boolean(),
  rejectedLocatorTop: z.boolean(),
});
